export const colorWhite = '#FFFFFF';
export const colorBlack = '#000000';
export const colorGrey = '#747577';
export const colorOrange = '#F59B1F';
